export type CountryInfo = {
  alpha2Code: string;
  i18nKey: string;
  dialingCode: string;
  placeholderCompanyName: string;
};

const countries: { [key: string]: CountryInfo } = {
  DE: {
    i18nKey: "countries.DE",
    alpha2Code: "DE",
    dialingCode: "+49",
    placeholderCompanyName: "Musterfirma GmbH",
  },
  AT: {
    i18nKey: "countries.AT",
    alpha2Code: "AT",
    dialingCode: "+43",
    placeholderCompanyName: "Musterfirma GmbH",
  },
  BE: {
    i18nKey: "countries.BE",
    alpha2Code: "BE",
    dialingCode: "+32",
    placeholderCompanyName: "Voorbeeld NV",
  },
  BG: {
    i18nKey: "countries.BG",
    alpha2Code: "BG",
    dialingCode: "+359",
    placeholderCompanyName: "Пример ООД",
  },
  HR: {
    i18nKey: "countries.HR",
    alpha2Code: "HR",
    dialingCode: "+385",
    placeholderCompanyName: "Primjer d.o.o.",
  },
  CY: {
    i18nKey: "countries.CY",
    alpha2Code: "CY",
    dialingCode: "+357",
    placeholderCompanyName: "Παράδειγμα Ltd.",
  },
  CZ: {
    i18nKey: "countries.CZ",
    alpha2Code: "CZ",
    dialingCode: "+420",
    placeholderCompanyName: "Příklad s.r.o.",
  },
  DK: {
    i18nKey: "countries.DK",
    alpha2Code: "DK",
    dialingCode: "+45",
    placeholderCompanyName: "Eksempel ApS",
  },
  EE: {
    i18nKey: "countries.EE",
    alpha2Code: "EE",
    dialingCode: "+372",
    placeholderCompanyName: "Näidis OÜ",
  },
  FI: {
    i18nKey: "countries.FI",
    alpha2Code: "FI",
    dialingCode: "+358",
    placeholderCompanyName: "Esimerkki Oy",
  },
  FR: {
    i18nKey: "countries.FR",
    alpha2Code: "FR",
    dialingCode: "+33",
    placeholderCompanyName: "Exemple SARL",
  },
  EL: {
    i18nKey: "countries.EL",
    alpha2Code: "EL",
    dialingCode: "+30",
    placeholderCompanyName: "Παράδειγμα ΑΕ",
  },
  HU: {
    i18nKey: "countries.HU",
    alpha2Code: "HU",
    dialingCode: "+36",
    placeholderCompanyName: "Példa Kft.",
  },
  IE: {
    i18nKey: "countries.IE",
    alpha2Code: "IE",
    dialingCode: "+353",
    placeholderCompanyName: "Example Ltd.",
  },
  IT: {
    i18nKey: "countries.IT",
    alpha2Code: "IT",
    dialingCode: "+39",
    placeholderCompanyName: "Esempio S.p.A.",
  },
  LV: {
    i18nKey: "countries.LV",
    alpha2Code: "LV",
    dialingCode: "+371",
    placeholderCompanyName: "Piemērs SIA",
  },
  LT: {
    i18nKey: "countries.LT",
    alpha2Code: "LT",
    dialingCode: "+370",
    placeholderCompanyName: "Pavyzdys UAB",
  },
  LU: {
    i18nKey: "countries.LU",
    alpha2Code: "LU",
    dialingCode: "+352",
    placeholderCompanyName: "Beispill S.à r.l.",
  },
  MA: {
    i18nKey: "countries.MA",
    alpha2Code: "MA",
    dialingCode: "+212",
    placeholderCompanyName: "مثال ش.م.",
  },
  MT: {
    i18nKey: "countries.MT",
    alpha2Code: "MT",
    dialingCode: "+356",
    placeholderCompanyName: "Eżempju Ltd.",
  },
  NL: {
    i18nKey: "countries.NL",
    alpha2Code: "NL",
    dialingCode: "+31",
    placeholderCompanyName: "Voorbeeld B.V.",
  },
  PL: {
    i18nKey: "countries.PL",
    alpha2Code: "PL",
    dialingCode: "+48",
    placeholderCompanyName: "Przykład Sp. z o.o.",
  },
  PT: {
    i18nKey: "countries.PT",
    alpha2Code: "PT",
    dialingCode: "+351",
    placeholderCompanyName: "Exemplo Lda.",
  },
  RO: {
    i18nKey: "countries.RO",
    alpha2Code: "RO",
    dialingCode: "+40",
    placeholderCompanyName: "Exemplu SRL",
  },
  RS: {
    i18nKey: "countries.RS",
    alpha2Code: "RS",
    dialingCode: "+381",
    placeholderCompanyName: "Primer d.o.o.",
  },
  SK: {
    i18nKey: "countries.SK",
    alpha2Code: "SK",
    dialingCode: "+421",
    placeholderCompanyName: "Príklad s.r.o.",
  },
  SI: {
    i18nKey: "countries.SI",
    alpha2Code: "SI",
    dialingCode: "+386",
    placeholderCompanyName: "Primer d.o.o.",
  },
  ES: {
    i18nKey: "countries.ES",
    alpha2Code: "ES",
    dialingCode: "+34",
    placeholderCompanyName: "Ejemplo S.L.",
  },
  SE: {
    i18nKey: "countries.SE",
    alpha2Code: "SE",
    dialingCode: "+46",
    placeholderCompanyName: "Exempel AB",
  },
  GB: {
    i18nKey: "countries.GB",
    alpha2Code: "GB",
    dialingCode: "+44",
    placeholderCompanyName: "Example Ltd.",
  },
  US: {
    i18nKey: "countries.US",
    alpha2Code: "US",
    dialingCode: "+1",
    placeholderCompanyName: "Example Inc.",
  },
};

/**
 * UK Crown Dependencies — these resolve to GB info but should not
 * appear as separate entries in country dropdowns.
 */
const crownDependencies: { [key: string]: CountryInfo } = {
  GG: countries.GB,
  JE: countries.GB,
  IM: countries.GB,
};

const allCountries = { ...countries, ...crownDependencies };

export type CountryCode = Extract<keyof typeof allCountries, string>;
export const COUNTRY_DICT = allCountries;
export const COUNTRY_LIST = Object.values(countries);
export const DEFAULT_COUNTRY_CODE: CountryCode = "DE";
export const DEFAULT_COUNTRY = COUNTRY_DICT[DEFAULT_COUNTRY_CODE];
